export default __webpack_public_path__ + "8b90c5486e22825151421e3a70ea7414.png";